// extracted by mini-css-extract-plugin
export default {"item__header":"ItemHeader_item__header__EdMHZ","header__logo":"ItemHeader_header__logo__yz5s3"};